// extracted by mini-css-extract-plugin
module.exports = {"root":"Collapsable_root__sg3v_","trigger":"Collapsable_trigger__549um","content":"Collapsable_content__KefMD","contentInner":"Collapsable_contentInner__wWEEr"};